
/**
 * @param {string} nodeName
 * @param {HTMLElement} node
 */
export function findCodeBlock(nodeName, node) {
	if (nodeName === 'pre') {
		let code, syntax;

		// pretty-print
		// @sample http://blog.csdn.net/csdnnews/article/details/78591437
		if (nodeName === 'pre'
			&& node.classList.contains('prettyprint')
			&& node.querySelector('.hljs'))
		{
			const numbering = node.querySelector('.pre-numbering');
			if (numbering) {
				numbering.remove();
			}
			const codeElement = node.querySelector('.hljs');
			code = codeElement.textContent;
			syntax = /hljs\s(\w+)\s/.test(codeElement.className) && RegExp.$1;
		}
		// plain code
		else {
			// 把 br 替换为换行符，否则用 br 换行的显示不正确
			const brs = Array.from(node.querySelectorAll('br'));
			for (let br of brs) {
				br.parentElement.replaceChild(document.createTextNode('\n'), br);
			}
			code = node.textContent;
			syntax = 'javascript';
		}
		const stripeEmptyLines = lines => {
			while (lines.length && !/\S/.test(lines[0])) {
				lines.shift();
			}
			while (lines.length && !/\S/.test(lines[lines.length - 1])) {
				lines.pop();
			}
			return lines;
		}
		const codeContent = stripeEmptyLines(code.split(/\r?\n/g)).join('\n');
		// 找到后清空子节点，防止递归执行
		while (node.firstChild) {
			node.removeChild(node.firstChild);
		}
		node.appendChild(document.createTextNode(codeContent));
		return {
			type: 'code-block',
			data: {
				syntax: syntax || 'javascript',
			}
		};
	}
}



// WEBPACK FOOTER //
// ./lib/convert/html/finder/findCodeBlock.js